import { IPortinForm } from "@common/portIn/IPortinForm";

export interface IPortinPayload {
    code?: string;
    msisdn: string;
    operator: string;
    serviceType: string;
}

export const getStateToPayload = (state: IPortinForm): IPortinPayload => ({
    code: state.portabilityCode,
    msisdn: state.phoneNumber,
    operator: state.provider,
    serviceType: state.currentSubscription,
});
